import { render } from "./ErrorHeader.vue?vue&type=template&id=39df880c"
const script = {}

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__